import {
  keepingFixed,
  layerBounds,
  render,
  renderOverlay,
} from './rendering.js'

const EDITOR_FONT_SIZE = 16
const EDITOR_MIN_HEIGHT = 28

// Grow the box to fit what is typed; no-op while hidden (scrollHeight is 0).
export function autoGrowTextEditor(state) {
  const el = state.textEditorEl
  if (!el || el.offsetParent === null) return
  el.style.height = 'auto'
  el.style.height = Math.max(EDITOR_MIN_HEIGHT, el.scrollHeight) + 'px'
}

export function openTextEditor(state, L, selectAll) {
  state.editingLayer = L
  state.editingSelectAll = !!selectAll
  const b = layerBounds(state, L),
    r = state.overlayEl.getBoundingClientRect(),
    wr = state.overlayEl.parentElement.getBoundingClientRect()
  state.textEditorEl.value = L.text === 'Text' ? '' : L.text
  state.textEditorEl.style.left =
    r.left - wr.left + b.x * state.viewScale + 'px'
  state.textEditorEl.style.top = r.top - wr.top + b.y * state.viewScale + 'px'
  state.textEditorEl.style.width = Math.max(60, b.w * state.viewScale) + 'px'
  state.textEditorEl.style.height =
    Math.max(EDITOR_MIN_HEIGHT, b.h * state.viewScale) + 'px'
  state.textEditorEl.style.fontFamily = L.font
  state.textEditorEl.style.fontSize = EDITOR_FONT_SIZE + 'px'
  state.textEditorEl.style.color = L.color
  L._editing = true
  renderOverlay(state)
  state.notify()
  // notify() is what un-hides the textarea, so measure on the next frame.
  requestAnimationFrame(() => autoGrowTextEditor(state))
}

export function commitTextEdit(state) {
  if (!state.editingLayer) return
  const L = state.editingLayer
  // Longer text means taller bounds; hold the top-left corner.
  keepingFixed(state, L, { x: L.x, y: L.y }, () => {
    L.text =
      state.textEditorEl.value.trim() === '' ? 'Text' : state.textEditorEl.value
  })
  L._editing = false
  state.editingLayer = null
  render(state)
  state.notify()
}

// Committing alone leaves the hidden textarea focused, keeping the keyboard up.
export function blurTextEditor(state) {
  if (!state.editingLayer) return
  commitTextEdit(state)
  if (state.textEditorEl) state.textEditorEl.blur()
}
